/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dev-config.vue?vue&type=template&id=8ed6e666&"
import script from "./dev-config.vue?vue&type=script&lang=js&"
export * from "./dev-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports